//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const benefitcode = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getBenefitCode(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/benefit-code?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function createBenefitCode(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/benefit-code`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function updateBenefitCode(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/benefit-code`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function exports(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/benefit-code/export?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  return {
    getBenefitCode,
    createBenefitCode,
    updateBenefitCode,
    exports
  };
};

export default benefitcode;
